import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { withStyles, Radio, Slide, Checkbox } from "@material-ui/core";
import {
  ChevronRight,
  ExpandLess,
  Visibility,
  VisibilityOff,
  CheckCircleOutline,
} from "@material-ui/icons";
import { withTranslation } from "react-i18next";
import { images } from "../utils/images";
import validator from "email-validator";
import {
  signUpRequest,
  resendVerificationCode,
  pushNotification,
  submitVerificationCode,
  fillVerificationResponse,
  cleanEmailCodeResent,
  // showVerificationScreen,
} from "../actions/index";
import ReCAPTCHA from "react-google-recaptcha";
import Loader from "../components/Loader";
import queryString from "query-string";

const sitekey = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_CAPTCHA_SITEKEY;

const termsUrl = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_TERMS_URL;
const privacyUrl = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_PRIVACY_URL;

const termsSolo = "https://sologenic.com/legal/user-agreement";
const privacySolo = "https://www.sologenic.com/legal/privacy-policy";

function SignUpContainer(props) {
  const {
    classes,
    t,
    account,
    signUpResponse,
    verificationResponse,
    emailVerificationError,
    emailCodeResent,
  } = props;
  const [email, setEmail] = useState("");
  const [validEmail, setValidEmail] = useState({
    validated: false,
    isValid: false,
  });
  const [pass, setPassword] = useState("");
  const [passConf, setPassConf] = useState("");
  const [inputType, setInputType] = useState("password");
  const [passConfirmed, setPassConfirmed] = useState(false);
  const [dataEmpty, setDataEmtpy] = useState(true);
  const [termsAgreed, setTermsAgreed] = useState(false);
  const [simAgreed, setSimAgreed] = useState(false);
  const [referrer, setReferrer] = useState("");
  const [haveReferrer, setHaveReferrer] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const [successSignUp, setSuccessSignUp] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [passRequirements, showPassRequirements] = useState(false);
  const [passError, showPassError] = useState(false);
  const [notMatchingPasswords, setMatchingPasswords] = useState(false);
  const [isPasswordInvalid, setPasswordInvalid] = useState(false);
  const [signUpBtnDisabled, setDisabledBtn] = useState(true);
  const [codeResent, setCodeResent] = useState(false);

  const [acquiredCaptcha, setAcquiredCaptcha] = useState(false);
  const [captchaReady, setCaptchaReady] = useState(true);
  const captchaRef = useRef();

  const getCaptcha = async () => {
    setCaptchaReady(false);
    captchaRef.current.reset();
    try {
      await captchaRef.current.executeAsync();

      setAcquiredCaptcha(true);
      setCaptchaReady(true);
    } catch (e) {
      return props.pushNotification({
        message: "Can't connect to Google ReCaptcha",
        type: "error",
      });
    }
  };
  useEffect(() => {
    const { search } = window.location;

    if (search.length) {
      const { referrer } = queryString.parse(search);

      if (referrer) {
        setHaveReferrer(true);
      }
    }
  }, []);

  useEffect(() => {
    const { search } = window.location;

    if (haveReferrer) {
      const { referrer } = queryString.parse(search);
      setReferrer(referrer);
    }
  }, [haveReferrer]);

  useEffect(() => {
    if (emailCodeResent.codeSent) {
      setCodeResent(true);
    }

    if (emailCodeResent.error) {
      props.pushNotification({
        message: "somethingWrong",
        type: "error",
      });
    }
  }, [emailCodeResent]);

  useEffect(
    function () {
      if (verificationResponse) {
        // props.showVerificationScreen(true);
        props.history.push("/id/verification");
        // props.fillVerificationResponse(false);
      }
      setAcquiredCaptcha(false);
    },
    [verificationResponse]
  );

  useEffect(() => {
    if (
      pass === "" ||
      passConf === "" ||
      email === "" ||
      !termsAgreed ||
      !simAgreed
    ) {
      setDisabledBtn(true);
    } else {
      setDisabledBtn(false);
    }
  }, [pass, passConf, email, termsAgreed, simAgreed]);

  useEffect(
    function () {
      if (signUpResponse.updated && signUpResponse.success) {
        setSuccessSignUp(true);
        setRequestSent(false);
      } else {
        setRequestSent(false);
        setDataEmtpy(true);
        setTermsAgreed(false);
        setReferrer("");
        setEmail("");
        setPassword("");
        setPassConf("");
        setPassConfirmed(false);
        setDisabledBtn(true);
        setValidEmail({
          validated: false,
          isValid: false,
        });
        setInputType("password");
      }
      setAcquiredCaptcha(false);
    },
    [signUpResponse]
  );

  const validateData = async () => {
    //     const isValidEmail = validator.validate(email);
    setDisabledBtn(true);

    if (validEmail.validated && validEmail.isValid) {
      if (!acquiredCaptcha) {
        await getCaptcha();
      }

      if (captchaRef.current) {
        const token = captchaRef.current.getValue();

        setRequestSent(true);
        props.cleanEmailCodeResent();
        if (token.length) {
          let obj = {
            email,
            password: pass,
            referrer,
            "g-recaptcha-response": token,
          };

          props.signUpRequest(obj);
        }
      }
    }
  };

  const validateEmail = () => {
    const isValidEmail = validator.validate(email);

    setValidEmail({ validated: true, isValid: isValidEmail });
  };

  const validatePassword = () => {
    let isPassConfirmed = pass === passConf ? true : false;
    setPassConfirmed(isPassConfirmed);
  };

  const submitCode = async () => {
    const email = signUpResponse.account.email;

    props.submitVerificationCode({
      email,
      confirmation_code: verificationCode.trim(),
    });
  };

  const validatePasswords = () => {
    if (pass === passConf) {
      setMatchingPasswords(false);
    } else {
      setMatchingPasswords(true);
    }
  };

  const validatePassRequirements = () => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})");

    if (strongRegex.test(pass)) {
      showPassRequirements(false);
      showPassError(false);
    } else {
      showPassRequirements(false);
      showPassError(true);
    }
  };

  const resendEmail = () => {
    let obj = {
      email: signUpResponse.account.email,
    };

    props.resendVerificationCode(obj);
  };

  const _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (!signUpBtnDisabled) {
        validateData();
      }
    }
  };

  // if (successSignUp) {
  //   return (
  //     <div className={classes.signUpContainer}>
  //       <Slide in direction="left">
  //         <div className="verifyEmail singleContainer">
  //           <h1>{t("checkInbox")}</h1>
  //           <p
  //             dangerouslySetInnerHTML={{
  //               __html: t("verificationNotice", {
  //                 user_email: signUpResponse.account.email,
  //               }),
  //             }}
  //           />
  //           <input
  //             type="text"
  //             onChange={(e) => setVerificationCode(e.target.value)}
  //             placeholder={t("enterVerificationCode")}
  //           />
  //           {emailVerificationError ? (
  //             <p
  //               className="passRequirements notMatch"
  //               style={
  //                 emailVerificationError
  //                   ? { height: "auto", marginBottom: 16 }
  //                   : { height: 0, overflow: "hidden" }
  //               }>
  //               <img src={images.icons.error} />
  //               {t(emailVerificationError)}
  //             </p>
  //           ) : (
  //             ""
  //           )}

  //           <button
  //             onClick={() => submitCode()}
  //             disabled={verificationCode === "" ? true : false}>
  //             {t("verify")}
  //           </button>

  //           {codeResent ? (
  //             <p className={classes.codeSent}>
  //               {t("codeSentEmail")} <CheckCircleOutline />
  //             </p>
  //           ) : (
  //             <span onClick={() => resendEmail()}>{t("noEmailReceived")}</span>
  //           )}
  //           <img
  //             className="img"
  //             src={
  //               theme === "defaultTheme"
  //                 ? images.illustrations.envelopeSolo
  //                 : images.illustrations.envelopeCF
  //             }
  //           />
  //         </div>
  //       </Slide>
  //     </div>
  //   );
  // }

  return (
    <div className={classes.signUpContainer}>
      <div className="leftSideSign">
        <img src={images.logos.sologenicWhiteLogo} />
        <h1>{t("_welcomeToSOLO")}</h1>
        <p>{t("_stepsAwaySolo")}</p>
        <p className="haveAcc">
          {t("_haveAcc")} <Link to="/id/login">{t("logIn")}</Link>
        </p>
        <img
          className="bitcoin"
          src={images.illustrations.signupIllustration}
        />
      </div>

      <div className="rightSideSign">
        <img className="smallLogo" src={images.logos.sologenicWhiteLogo} />

        {successSignUp ? (
          <Slide in direction="left">
            <div className="verifyEmail singleContainer">
              <h1>{t("checkInbox")}</h1>
              <p
                dangerouslySetInnerHTML={{
                  __html: t("verificationNotice2", {
                    user_email: signUpResponse.account.email,
                  }),
                }}
              />
              <input
                type="text"
                onChange={(e) => setVerificationCode(e.target.value)}
                placeholder={t("enterVerificationCode")}
              />
              {emailVerificationError ? (
                <p
                  className="passRequirements notMatch"
                  style={
                    emailVerificationError
                      ? { height: "auto", marginBottom: 16 }
                      : { height: 0, overflow: "hidden" }
                  }
                >
                  <img src={images.icons.error} />
                  {t(emailVerificationError)}
                </p>
              ) : (
                ""
              )}

              <button
                onClick={() => submitCode()}
                disabled={verificationCode === "" ? true : false}
              >
                {t("verify")}
              </button>

              {codeResent ? (
                <p className={classes.codeSent}>
                  {t("codeSentEmail")} <CheckCircleOutline />
                </p>
              ) : (
                <span onClick={() => resendEmail()}>
                  {t("noEmailReceived")}
                </span>
              )}
              <img className="img" src={images.illustrations.envelopeSolo} />
            </div>
          </Slide>
        ) : requestSent ? (
          <div className="loaderWrapper">
            <Loader />
          </div>
        ) : (
          <div
            className="createAccount singleContainer"
            onKeyDown={(e) => _handleKeyDown(e)}
          >
            <h1>{t("letsCreateSolo")}</h1>
            <div className="inputs">
              <div className="inputContainer">
                <input
                  type="email"
                  placeholder={t("usernamePlaceholder")}
                  onChange={(e) => setEmail(e.target.value)}
                  onBlur={() => validateEmail()}
                />
              </div>
              <div className="inputContainer">
                <input
                  type={inputType}
                  placeholder={t("createPW")}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={() => {
                    showPassRequirements(true);
                    showPassError(false);
                  }}
                  onBlur={() => validatePassRequirements()}
                  className={
                    isPasswordInvalid || passError ? "invalidField" : ""
                  }
                />
                {inputType === "password" ? (
                  <Visibility onClick={() => setInputType("text")} />
                ) : (
                  <VisibilityOff onClick={() => setInputType("password")} />
                )}
              </div>
              <p
                className="passRequirements"
                style={
                  passRequirements
                    ? { height: "auto", marginBottom: 16 }
                    : { height: 0, overflow: "hidden" }
                }
              >
                <img src={images.icons.lock} />
                {t("passRequirements")}
              </p>
              <p
                className="passRequirements notMatch"
                style={
                  passError
                    ? { height: "auto", marginBottom: 16 }
                    : { height: 0, overflow: "hidden" }
                }
              >
                <img src={images.icons.error} />
                {t("passError")}
              </p>
              <div className="inputContainer">
                <input
                  type={inputType}
                  placeholder={t("confPW")}
                  onChange={(e) => setPassConf(e.target.value)}
                  onBlur={() => validatePasswords()}
                  className={notMatchingPasswords ? "invalidField" : ""}
                />
                {inputType === "password" ? (
                  <Visibility onClick={() => setInputType("text")} />
                ) : (
                  <VisibilityOff onClick={() => setInputType("password")} />
                )}
              </div>
              {notMatchingPasswords ? (
                <p
                  className="passRequirements notMatch"
                  style={{ marginBottom: 16 }}
                >
                  <img src={images.icons.error} />
                  {t("passwordsDontMatch")}
                </p>
              ) : (
                ""
              )}
            </div>

            <div className="referralContainer">
              <p onClick={() => setHaveReferrer(!haveReferrer)}>
                {t("haveRefCode")}{" "}
                {haveReferrer ? <ExpandLess /> : <ChevronRight />}
              </p>
              {haveReferrer ? (
                <div className="referralInput">
                  <input
                    value={referrer}
                    type="text"
                    placeholder={t("enterRefCode")}
                    onChange={(e) => setReferrer(e.target.value)}
                  />
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="agreeWithTerms">
              <Checkbox
                checked={simAgreed}
                onClick={() => setSimAgreed(!simAgreed)}
                classes={{ root: classes.radio, checked: classes.checked }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t("_simTerms", {
                    countriesUrl:
                      "https://www.sologenic.com/legal/available-countries",
                  }),
                }}
              />
            </div>

            <div className="agreeWithTerms">
              <Checkbox
                checked={termsAgreed}
                onClick={() => setTermsAgreed(!termsAgreed)}
                classes={{ root: classes.radio, checked: classes.checked }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t("readTerms", {
                    termsUrl: termsSolo,
                    privacyUrl: privacySolo,
                  }),
                }}
              />
            </div>

            <ReCAPTCHA
              ref={captchaRef}
              sitekey={sitekey}
              theme="dark"
              size="invisible"
            />

            <button
              onClick={() => validateData()}
              disabled={signUpBtnDisabled}
              className={"soloSignupBtn"}
            >
              {t("signUp")}
            </button>
            <span className="haveAcc">
              {t("haveAccount")}
              <Link to="/id/login">{t("login")}</Link>
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    account: state.account,
    signUpResponse: state.signUpResponse,
    verificationResponse: state.verificationResponse,
    emailVerificationError: state.emailVerificationError,
    emailCodeResent: state.emailCodeResent,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      signUpRequest,
      submitVerificationCode,
      resendVerificationCode,
      pushNotification,
      fillVerificationResponse,
      cleanEmailCodeResent,
    },
    dispatch
  );
}

const styles = (theme) => ({
  signUpContainer: {
    color: theme.colors.text.primary,
    display: "flex",
    height: "100%",
    "& .leftSideSign": {
      width: "40%",
      padding: "120px 80px 0 80px",
      position: "relative",
      overflow: "hidden",
      background: theme.colors.background.fore,
      minHeight: 950,
      "& img": {
        width: 180,
        height: "auto",
      },

      "& h1": {
        fontSize: 48,
        marginTop: 70,
        marginBottom: 16,
        fontWeight: 700,
      },
      "& p": {
        fontSize: 20,
        lineHeight: "30px",
        marginBottom: 32,
        color: theme.colors.text.secondary,
      },
      "& .haveAcc": {
        fontSize: 28,

        "& a": {
          ...theme.defaults.link,
        },
      },
      "& .bitcoin": {
        position: "absolute",
        left: 0,
        bottom: 0,
        maxWidth: 330,
        width: "80%",
        transform: "translateY(15%)",
      },
      [theme.breakpoints.down(1200)]: {
        paddingRight: 40,
      },
      [theme.breakpoints.down(1024)]: {
        paddingRight: 24,
      },
    },
    "& .rightSideSign": {
      width: "60%",
      height: "100%",
      minHeight: 950,
      background: theme.colors.background.rightSideSignUp,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      "& .smallLogo": {
        display: "none",
        width: 180,
        height: "auto",
        marginTop: 24,
        marginBottom: 32,
      },
      "& .loaderWrapper": {
        height: 450,
        width: 560,
        marginTop: 32,
        background: theme.colors.background.fore,
      },
      "& .soloLogo": {
        width: 220,
        marginTop: 80,
      },
      "& b": {
        fontWeight: 600,
      },
      "& .createAccount": {
        background: theme.colors.background.fore,
        marginTop: 32,
        width: "100%",
        maxWidth: 560,
        borderRadius: 2,
        height: "auto",
        display: "flex",
        flexDirection: "column",
        padding: "40px 75px",
        alignItems: "center",
        [theme.breakpoints.down(400)]: {
          width: "100%",
          padding: "40px 0",
          boxShadow: "none",
          borderRadius: 0,
        },
        "& h1": {
          fontSize: 28,
          textAlign: "center",
          width: "100%",
          fontWeight: 600,
        },
        "& .inputs": {
          marginTop: 40,
          "& .inputContainer": {
            position: "relative",
            width: "100%",
            marginBottom: 16,
            maxWidth: 400,
            [theme.breakpoints.down(450)]: {
              display: "flex",
              width: 300,
              marginLeft: "auto",
              marginRight: "auto",
            },
            "& input": {
              ...theme.defaults.input,
              maxWidth: "none",
              width: "100%",
              color: theme.colors.text.primary,
              // fontFamily: "Titillium Web",
              fontSize: 16,
              fontWeight: 300,

              "&:focus": {
                border: `1px solid ${theme.colors.text.primary}`,
                fontWeight: 500,
              },

              "&:placeholder": {
                fontSize: 16,
              },
              "&.invalidField": {
                borderColor: theme.colors.buttons.sell,
              },
            },

            "& svg": {
              position: "absolute",
              right: 0,
              top: "50%",
              transform: "translate(-125%, -50%)",
              color: theme.colors.text.secondary,
              fontSize: 20,
            },
          },

          "& .passRequirements": {
            fontSize: 14,
            // fontFamily: "Titillium Web",
            lineHeight: "21px",
            color: theme.colors.buttons.green,
            display: "flex",
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
            "& img": {
              width: 12,
              height: 12,
              marginRight: 6,
              marginTop: 4,
            },

            "&.notMatch": {
              color: theme.colors.buttons.sell,
              "& img": {
                width: 16,
                height: 16,
                marginRight: 6,
                marginTop: 0,
              },
            },
          },
        },
        "& .referralContainer": {
          width: 400,
          marginBottom: 16,
          [theme.breakpoints.down(450)]: {
            width: 300,
          },
          "& p": {
            display: "flex",
            alignItems: "center",
            marginBottom: 8,
            cursor: "pointer",
            fontSize: 14,
            // fontFamily: "Titillium Web",
            color: theme.colors.misc._blue,
            fontWeight: 600,
            "&:hover": {
              textDecoration: "underline",
            },
            "& svg": {
              fontSize: 16,
            },
          },
          "& input": {
            ...theme.defaults.input,
            maxWidth: "none",
            width: 400,
            color: theme.colors.text.primary,
            // fontFamily: "Titillium Web",
            fontSize: 16,
            fontWeight: 300,
            [theme.breakpoints.down(450)]: {
              width: 300,
              marginLeft: "auto",
              marginRight: "auto",
            },
            "&:focus": {
              border: `1px solid ${theme.colors.text.primary}`,
              fontWeight: 500,
            },
            "&:placeholder": {
              fontSize: 16,
            },
          },
        },
        "& .agreeWithTerms": {
          display: "flex",
          width: 400,
          marginBottom: 16,
          border: `1px solid ${theme.colors.misc.dividers}`,
          borderRadius: 2,
          padding: 14,
          paddingLeft: 0,
          [theme.breakpoints.down(450)]: {
            width: 300,
          },
          "& p": {
            color: theme.colors.text.primary,
            fontSize: 14,
            lineHeight: "18px",
            // fontFamily: "Titillium Web",
            "& a": {
              ...theme.defaults.link,
            },
          },
        },
        "& .signupButton, & .soloSignupBtn": {
          ...theme.defaults.squareBtn,
          background: theme.colors.buttons.green,
          marginTop: 16,
          marginBottom: 16,
          width: "100%",
        },
        "& .soloSignupBtn": {
          borderRadius: 25,
          maxWidth: 150,
        },
        "& .haveAcc": {
          display: "flex",
          fontSize: 14,
          color: theme.colors.text.secondary,
          display: "none",
          [theme.breakpoints.down(900)]: {
            display: "block",
          },
          "& a": {
            marginLeft: 5,
            // fontWeight: 600,
            ...theme.defaults.link,
          },
        },
      },
      "& .verifyEmail": {
        display: "flex",
        flexDirection: "column",
        maxWidth: 880,
        width: "95%",
        overflow: "hidden",
        position: "relative",
        background: theme.colors.background.fore,
        padding: "40px 200px 40px 80px",
        justifyContent: "space-between",
        marginTop: 42,

        [theme.breakpoints.down(600)]: {
          padding: 24,
        },
        "& input": {
          ...theme.defaults.input,
          marginBottom: 8,
          color: theme.colors.text.primary,
        },
        "& .passRequirements": {
          fontSize: 14,
          // fontFamily: "Titillium Web",
          lineHeight: "21px",
          color: theme.colors.text.secondary,
          display: "flex",
          "& img": {
            width: 12,
            height: 12,
            marginRight: 6,
            marginTop: 4,
          },

          "&.notMatch": {
            "& img": {
              width: 16,
              height: 16,
              marginRight: 6,
              marginTop: 0,
              position: "relative",
            },
          },
        },
        "& button": {
          ...theme.defaults.roundBtn,
          marginTop: 8,
          marginBottom: 12,
          width: "100%",
          maxWidth: 320,
          background: theme.colors.buttons.green,
        },
        "& .img": {
          position: "absolute",
          right: 0,
          top: 0,
          height: "130%",
          width: "auto",
          transform: "translate(35%, -12%)",
          [theme.breakpoints.down(600)]: {
            display: "none",
          },
        },
        "& h1": {
          fontSize: 28,
          fontWeight: 600,
        },
        "& p": {
          color: theme.colors.text.secondary,
          marginBottom: 16,
          marginTop: 8,
          lineHeight: "21px",
          fontSize: 14,
          // fontFamily: "Titillium Web",
          width: "70%",
          "& b": {
            color: theme.colors.text.primary,
          },
        },
        "& span": {
          fontSize: 18,
          textDecoration: "underline",
          transition: ".3s",
          cursor: "pointer",
          // fontFamily: "Titillium Web",
          "&:hover": {
            opacity: 0.5,
          },
        },
      },
      // "& .verifyEmail": {
      //   display: "flex",
      //   flexDirection: "column",
      //   maxWidth: 880,
      //   width: "95%",
      //   overflow: "hidden",
      //   position: "relative",
      //   background: theme.colors.background.fore,
      //   padding: "40px 200px 40px 80px",
      //   justifyContent: "space-between",
      //   marginTop: 42,
      //   "& input": {
      //     ...theme.defaults.input,
      //     marginBottom: 8,
      //   },
      //   "& .passRequirements": {
      //     fontSize: 14,
      //     // fontFamily: "Titillium Web",
      //     lineHeight: "21px",
      //     color: theme.colors.text.secondary,
      //     display: "flex",
      //     "& img": {
      //       width: 12,
      //       height: 12,
      //       marginRight: 6,
      //       marginTop: 4,
      //     },

      //     "&.notMatch": {
      //       "& img": {
      //         width: 16,
      //         height: 16,
      //         marginRight: 6,
      //         marginTop: 0,
      //         position: "relative",
      //       },
      //     },
      //   },
      //   "& button": {
      //     ...theme.defaults.roundBtn,
      //     marginTop: 8,
      //     marginBottom: 12,
      //     width: "50%",
      //     background: theme.colors.buttons.green,
      //   },
      //   "& .img": {
      //     position: "absolute",
      //     right: 0,
      //     top: 0,
      //     height: "130%",
      //     width: "auto",
      //     transform: "translate(35%, -12%)",
      //   },
      //   "& h1": {
      //     fontSize: 28,
      //     fontWeight: 600,
      //   },
      //   "& p": {
      //     color: theme.colors.text.secondary,
      //     marginBottom: 16,
      //     marginTop: 8,
      //     lineHeight: "21px",
      //     fontSize: 14,
      //     // fontFamily: "Titillium Web",
      //     width: "70%",
      //     "& b": {
      //       color: theme.colors.text.primary,
      //     },
      //   },
      //   "& span": {
      //     fontSize: 14,
      //     color: theme.colors.misc._blue,
      //     transition: ".3s",
      //     fontWeight: 600,
      //     cursor: "pointer",
      //     // fontFamily: "Titillium Web",
      //     "&:hover": {
      //       opacity: 0.5,
      //     },
      //   },
      // },
    },
    [theme.breakpoints.down(900)]: {
      "& .leftSideSign": {
        display: "none",
      },
      "& .rightSideSign": {
        width: "100%",
        justifyContent: "flex-start",
        "& .smallLogo": {
          display: "block !important",
        },
      },
    },
  },
  radio: {
    color: theme.colors.text.primary,
    height: 30,
    "& svg": {
      fontSize: 20,
    },
  },
  checked: {
    color: `${theme.colors.buttons.green} !important`,
  },
  codeSent: {
    fontSize: "18px !important",
    // fontFamily: "Titillium Web",
    color: theme.colors.text.secondary,
    display: "flex",
    alignItems: "center",
    "& svg": {
      marginLeft: 5,
      color: theme.colors.buttons.buy,
    },
  },
});

export default withStyles(styles)(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(SignUpContainer)
  )
);
